/* Core & libraries */
import React, { Suspense, useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { lazyWithPreload } from "helpers/lazyLoadingHelpers";

/* Components */
import { ReactComponent as UploadIcon } from "../../../resources/images/upload-icon-no-border.svg";
import { ReactComponent as DownloadIcon } from "../../../resources/images/download.svg";
import UCButton from "../../buttons";
import SpinnerBasic from "components/spinners/SpinnerBasic";

/* Styles */
import styles from "./styles";
import { AA_RETRO_SAMPLE } from '../../../constants/appConstants';

/* Components lazy-loaded */
export const RetroAtmBulkImportModalLazy = lazyWithPreload(() => import('../../modals/retroAtmBulkImportModal'));

const AtmBulkImport = ({onUploadCompleted} ) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const downloadCsv = () => {
    const downloadFile = (fileUrl, fileName) => {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    downloadFile(AA_RETRO_SAMPLE, 'RequestingMilesTemplate.xlsx');
  };


  const [showAtmBulkImportModal, setShowAtmBulkImportModal] = useState(false)

  return (
    <div className={classes.mainDiv}>
      <div className={classes.bodyContainer}>
        <h6 className={classes.title}>
          <FormattedMessage id="retro.atmBulkImport.title" />
        </h6>
        <p className={classes.secondaryText1}>
          <FormattedMessage id="retro.atmBulkImport.subtitle" />
        </p>
        <hr className={classes.divider} />
        <div className={classes.firstStepContainer}>
          <p className={classes.stepTitle}>
            <FormattedMessage id="retro.atmBulkImport.step1.title" />
          </p>
          <UCButton
            onClick={() => downloadCsv()}
            type="default"
            className={classes.importBtn}
            text={<FormattedMessage id="retro.atmBulkImport.downloadBtnText" />}
            iconEnd={<DownloadIcon />}
            spinner={{
              name: 'loyaltyAtmDownloadSpinner',
              size: 20,
            }}
            loadingStateStyling={classes.downloadBtnLoadingState}
          />
        </div>
        <div className={classes.firstStepContainer}>
          <p className={classes.stepTitle}>
            <FormattedMessage id="retro.atmBulkImport.step2.title" />
          </p>
          <p className={classes.secondaryText2}>
            <FormattedMessage id="retro.atmBulkImport.step2.subtitle" />
          </p>
        </div>
        <div>
          <ul className={classes.list}>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="retro.atmBulkImport.pnr" />
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="retro.atmBulkImport.pnrDescription" />
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="retro.atmBulkImport.ticketNr" />
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="retro.atmBulkImport.ticketNrDescription" />
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="retro.atmBulkImport.aadv" />
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="retro.atmBulkImport.aadvDescription" />
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="retro.atmBulkImport.travelerName" />
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="retro.atmBulkImport.travelerNameDescription" />
              </p>
            </li>
            <li>
              <p className={classes.listItem}>
                <FormattedMessage id="retro.atmBulkImport.departureDate" />
              </p>
              <p className={classes.secondaryText2}>
                <FormattedMessage id="retro.atmBulkImport.departureDateDescription" />
              </p>
            </li>
          </ul>

          <div className={classes.secondStepContainer}>
            <p className={classes.stepTitle}>
              <FormattedMessage id="retro.atmBulkImport.step3.title" />
            </p>
            <p className={classes.secondaryText2}>
              <FormattedMessage id="retro.atmBulkImport.step3.subtitle" />
            </p>
          </div>
          <UCButton
            onClick={() => setShowAtmBulkImportModal(true)}
            type="default"
            className={classes.importBtn}
            text={<FormattedMessage id="retro.atmBulkImport.uploadBtnText" />}
            iconEnd={<UploadIcon />}
          />
        </div>
      </div>
      <Suspense fallback={showAtmBulkImportModal ? <SpinnerBasic /> : null}>
        <RetroAtmBulkImportModalLazy
          showAtmBulkImportModal={showAtmBulkImportModal}
          setShowAtmBulkImportModal={setShowAtmBulkImportModal}
          onUploadCompleted={onUploadCompleted}
        />
      </Suspense>
    </div>
  );
};

export default AtmBulkImport;
